import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import rootReducerCreator from '@/combineReducer';
import rootSagaCreator from '@/combineSaga';

const middlewares = [];
const sagaMiddleware = createSagaMiddleware();

if (import.meta.env.MODE !== 'production') {
	const logger = createLogger({
		level: 'info',
		collapsed: true,
	});

	middlewares.push(logger);
}

const composeEnhancers =
	import.meta.env.MODE !== 'production' &&
	typeof window === 'object' &&
	window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
		: compose;

const enhancers = composeEnhancers(applyMiddleware(sagaMiddleware, ...middlewares));

const store = createStore(rootReducerCreator(), enhancers);
sagaMiddleware.run(rootSagaCreator);

export { store };
